import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

const SimpleMovieForm = ({ movie, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    name: movie?.name || '',
    origin_name: movie?.origin_name || '',
    description: movie?.description || '',
    status: movie?.status || 'ongoing',
    year: movie?.year || new Date().getFullYear(),
    quality: movie?.quality || 'HD'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="simple-movie-form">
      <div className="form-header">
        <h2>{movie ? 'Chỉnh sửa phim' : 'Thêm phim mới'}</h2>
        <button onClick={onCancel} className="close-btn">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="movie-form">
        <div className="form-group">
          <label>Tên phim</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Nhập tên phim"
            required
          />
        </div>

        <div className="form-group">
          <label>Tên gốc</label>
          <input
            type="text"
            name="origin_name"
            value={formData.origin_name}
            onChange={handleChange}
            placeholder="Nhập tên gốc"
          />
        </div>

        <div className="form-group">
          <label>Mô tả</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Nhập mô tả phim"
            rows={4}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Trạng thái</label>
            <select name="status" value={formData.status} onChange={handleChange}>
              <option value="ongoing">Đang phát sóng</option>
              <option value="completed">Hoàn thành</option>
              <option value="dropped">Tạm dừng</option>
              <option value="upcoming">Sắp chiếu</option>
            </select>
          </div>

          <div className="form-group">
            <label>Năm</label>
            <input
              type="number"
              name="year"
              value={formData.year}
              onChange={handleChange}
              min="1900"
              max="2030"
            />
          </div>

          <div className="form-group">
            <label>Chất lượng</label>
            <select name="quality" value={formData.quality} onChange={handleChange}>
              <option value="HD">HD</option>
              <option value="FHD">FHD</option>
              <option value="4K">4K</option>
              <option value="CAM">CAM</option>
            </select>
          </div>
        </div>

        <div className="form-actions">
          <button type="button" onClick={onCancel} className="btn-cancel">
            Hủy
          </button>
          <button type="submit" className="btn-save">
            <FontAwesomeIcon icon={faSave} />
            {movie ? 'Cập nhật' : 'Thêm phim'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SimpleMovieForm;

